import { Outlet, useLocation } from "react-router-dom";
import { SideNavPageLayout } from "shared/components";

const titleMap: Record<string, string> = {
  settings: "Settings",
  admin: "Admin Settings",
};

export const TenantLayout = () => {
  const location = useLocation();
  const lastSegment = location.pathname.split("/").filter(Boolean).pop() ?? "";
  const title = titleMap[lastSegment] ?? "Settings";

  return (
    <SideNavPageLayout title={title}>
      <Outlet />
    </SideNavPageLayout>
  );
};
